const isBeforeDate = (startDate, EndDate) => {

    if (!startDate || !EndDate) return false;
    return new Date(startDate) < new Date(EndDate);
};



const handleRange = (type = "", val, filter) => {

    if (!val) return true

    if (type === 'Greater Than') {
        return val <= filter
    }

    if (type === 'Less Than') {
        return val >= filter
    }


    if (type === "Between") {
        const [min, max] = val.split("-").map((v) => Number(v.trim()));


        return filter >= min && filter <= max
    }
    return true
}

const toNum = (val) => {
    if (val === null || val === undefined) return null;
    if (typeof val === "string") {
        const s = val.trim().replace("%", "");
        if (s === "") return null;
        const n = Number(s);
        return Number.isNaN(n) ? null : n;
    }
    const n = Number(val);
    return Number.isNaN(n) ? null : n;
};

const handleAboveBelow = (above, below, value) => {

    if (above == "" && below == "") return true


    const min = toNum(above);
    const max = toNum(below);
    const val = toNum(value);

    console.log(min, max, val);

    if (val === null) return false;

    const hasMin = min !== null;
    const hasMax = max !== null;

    if (!hasMin && !hasMax) return true;
    if (hasMin && hasMax) return val >= min && val <= max;
    if (hasMin) return val >= min;
    return val <= max;
};

const toNumber = (val) => Number(val?.toString().replace("%", "") || 0);


function filterApplicant(applicant = [], filters = {}) {


    let filtOut = [];

    console.log(filters);


    applicant?.forEach((applicant, index) => {

        if (
            (!filters?.personalityMatch?.length || filters.personalityMatch.includes(applicant?.personalityMatch)) &&
            (!filters?.profileMatch?.length || filters.profileMatch.includes(applicant?.applicationMatch)) &&
            (!filters?.educationLevels?.length || filters.educationLevels.includes(applicant?.educationLevel)) &&
            (
                !filters?.educationArea?.length ||
                filters.educationArea.some(
                    (title) => title.toLowerCase() === applicant?.feildOfEducation?.toLowerCase()
                )
            ) &&
            (!filters?.industry?.length || filters.industry.includes(applicant?.currentIndustry)) &&
            (!filters?.departments?.length || filters.departments.includes(applicant?.departmentName)) &&
            (!filters?.quizScore?.length || filters.quizScore.includes(applicant?.quizScore)) &&
            (
                !filters?.currentTitle?.length ||
                filters.currentTitle.some(
                    (title) => title.toLowerCase() === applicant?.roleName?.toLowerCase()
                )
            ) &&
            (!filters?.expectedSal?.length || filters.expectedSal.includes(applicant?.expectedCTC)) &&
            (!filters?.graph1?.length || filters.graph1.includes(applicant?.profile_1)) &&
            (!filters?.graph2?.length || filters.graph2.includes(applicant?.profile_2)) &&
            (!filters?.graph3?.length || filters.graph3.includes(applicant?.profile_3)) &&
            (!filters?.question1?.length || filters?.question1?.toString().toLowerCase().trim() === applicant?.customQuestion1?.toString().toLowerCase().trim()) &&
            (!filters?.question2?.length || filters?.question2?.toString().toLowerCase().trim() === applicant?.customQuestion2?.toString().toLowerCase().trim()) &&
            (!filters?.question3?.length || filters?.question3?.toString().toLowerCase().trim() === applicant?.customQuestion3?.toString().toLowerCase().trim()) &&
            (!filters?.question4?.length || filters?.question4?.toString().toLowerCase().trim() === applicant?.customQuestion4?.toString().toLowerCase().trim()) &&
            (!filters?.question5?.length || filters?.question5?.toString().toLowerCase().trim() === applicant?.customQuestion5?.toString().toLowerCase().trim()) &&
            (!filters?.question6?.length || filters?.question6?.toString().toLowerCase().trim() === applicant?.customQuestion6?.toString().toLowerCase().trim()) &&
            (!filters?.availDateBef?.length || isBeforeDate(applicant?.availableDate, filters?.availDateBef)) &&
            handleAboveBelow(filters?.expAbo, filters?.expBel, applicant?.experience) &&
            handleAboveBelow(filters?.primaryPerAbo, filters?.primaryPErBel, applicant?.primaryMatch) &&
            handleAboveBelow(filters?.secoundryPersonlityAbo, filters?.secoundryPersonlityBel, applicant?.secondaryMatch)
        ) {
            filtOut.push(applicant);
        }


    })


    return filtOut
}

export default filterApplicant